import * as Icons from '@ant-design/icons'
import classNames from 'classnames'
import type React from 'react'
import { type AntIcons, ICONS as CustomIcons, type IconType } from './iconTypes'

export type IconProps = {
  color?: string
  /**
   * Name of the component. Needs to be a
valid Antd icon, see https://ant.design/components/icon/
for a list of all icons.
   */
  name?: AntIcons | string
  size?: number
  /**
   * Style object. N.B. use font size
to set the size of the icon.
   */
  style?: React.CSSProperties
  customIcon?: IconType
  width?: number
  height?: number
  className?: string
  onClick?: () => void
}

export const createSvgContent = (data: string, iconStyle: object) => (
  <path d={data} style={iconStyle} />
)

export const getIsCustomIcon = (
  customIcon?: string,
  name?: IconProps['name']
) => {
  if (customIcon || CustomIcons[name as IconType]) {
    return true
  }

  return false
}

export function Icon({
  color,
  name,
  size,
  style,
  width,
  height,
  customIcon,
  className,
  onClick
}: IconProps) {
  const isCustomIcon = getIsCustomIcon(customIcon, name)

  if (isCustomIcon) {
    const {
      viewBox,
      data,
      style: iconStyle
      // @ts-ignore
    } = CustomIcons[customIcon] || CustomIcons[name]

    const svgContent =
      typeof data === 'string' ? createSvgContent(data, iconStyle) : data

    return (
      <svg
        aria-hidden="true"
        width={width || size || 18}
        height={height || size || 18}
        viewBox={viewBox || '0 0 32 32'}
        className={classNames('ui-kit', className)}
        style={style}
        onClick={onClick}
      >
        {svgContent}
      </svg>
    )
  }

  const Icon = Icons[name as AntIcons]

  const iconStyle = {
    color,
    fontSize: size,
    ...style
  }

  return Icon ? <Icon className={className} style={iconStyle} /> : null
}

export default Icon
